import * as React from "react";

export default function SoundICON(props) {
  return (
    <svg
      fill="#999"
      viewBox="0 0 512 460"
      width={68}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M15 365.573h78.459l168.338 92.671c18.896 10.401 42.013-3.266 42.013-24.83V78.587c0-21.553-23.107-35.237-42.013-24.83L93.459 146.428H15c-8.284 0-15 6.716-15 15v189.145c0 8.284 6.716 15 15 15zM273.81 81.389v349.222l-161.495-88.904V170.293zM30 176.428h52.315v159.145H30zM424.962 97.101c-5.857 5.858-5.856 15.356.003 21.213C461.745 155.083 482 203.98 482 255.996c0 52.015-20.255 100.912-57.035 137.682-9.38 9.377-2.771 25.613 10.605 25.613 4.225 0 8.042-1.748 10.768-4.56C488.683 372.312 512 315.949 512 255.996c0-60.031-23.377-116.461-65.825-158.898-5.858-5.858-15.356-5.856-21.213.003z" />
      <path d="M382.542 351.266c-5.857 5.859-5.855 15.356.004 21.213 5.857 5.856 15.356 5.856 21.213-.004C434.868 341.355 452 299.99 452 256s-17.132-85.354-48.242-116.475c-5.857-5.859-15.354-5.861-21.213-.004s-5.861 15.354-.004 21.213C407.987 186.189 422 220.022 422 256s-14.013 69.811-39.458 95.266z" />
      <path d="M340.11 330.044c5.856 5.859 15.353 5.863 21.213.006C381.105 310.28 392 283.982 392 256s-10.895-54.28-30.676-74.05c-5.86-5.856-15.357-5.853-21.213.006-5.856 5.86-5.853 15.357.006 21.213C354.229 217.273 362 236.036 362 256s-7.771 38.727-21.883 52.83c-5.86 5.856-5.863 15.354-.007 21.214z" />
    </svg>
  );
}
